module.exports = __webpack_public_path__ + "static/media/27OCHA20.a4ec6bbb.jpg";